/* ric2-dien-thoai.js — tối ưu điện thoại cho trang "Rooted in Christ" (23/10/2026, haipq).
 *
 * 5 phần độc lập, phần nào lỗi không kéo phần khác:
 *   1. Ẩn thanh mua dính đáy khi khung mua (đầu trang) đang hiện — tránh che nút mua.
 *   2. Thư viện ảnh khung mua: bấm ảnh nhỏ đổi ảnh chính; bấm ảnh chính phóng to, vuốt qua lại.
 *   3. "Included in your $… plan": tick xanh lấy từ bảng so sánh gói, đổi theo gói đang chọn.
 *   4. Nút − / + to rõ cho ô số lượng.
 *   5. Nút mua thêm giỏ tại chỗ như pheu-199: ngăn giỏ bung ra, hộp đăng ký tự vào.
 *
 * Giữ LUẬT CỨNG của ric2-script.js: không gỡ `disabled` của nút mua, không đổi `value` ô variant id.
 * Tệp này chỉ đổi số lượng (quantity, tối thiểu 1), cách hiển thị và cách gửi form mua.
 */
(function(){"use strict";var goc=document.querySelector(".ric2-root");if(!goc)return;var mua=goc.querySelector(".ric2-mua"),dinh=goc.querySelector(".pdinh");if(!mua||!dinh||!("IntersectionObserver"in window))return;new IntersectionObserver(function(e){dinh.classList.toggle("is-an",e[0].isIntersecting)}).observe(mua)})();

/* ric2 thu vien anh khung mua: bam anh nho -> doi anh chinh; bam anh chinh -> phong to toan man hinh, vuot qua lai. Dan vao CUOI ric2-script.js */
(function () {
  "use strict";
  var goc = document.querySelector(".ric2-root");
  if (!goc) return;
  var media = goc.querySelector(".ric2-mua__media");
  if (!media) return;
  var oChinh = media.querySelector(".ric2-mua__anh-chinh");
  var chinh = oChinh && oChinh.querySelector("img");
  var day = media.querySelector(".ric2-mua__day");
  if (!chinh || !day) return;

  // anh chinh cung thanh 1 anh nho dau tien, de bam quay lai duoc
  var li0 = document.createElement("li");
  li0.appendChild(chinh.cloneNode(false));
  day.insertBefore(li0, day.firstChild);
  day.classList.add("ric2-tv-day");

  // bo qua o anh con trong (snippet ric2-anh in div "Replace image" thay vi img)
  var lis = [].slice.call(day.children).filter(function (li) { return li.querySelector("img"); });
  // anh chu shop tai len co srcset: phai doi ca srcset, khong thi trinh duyet giu anh cu
  var anh = lis.map(function (li) {
    var i = li.querySelector("img");
    return { src: i.getAttribute("src"), srcset: i.getAttribute("srcset") || "", alt: i.getAttribute("alt") || "" };
  });
  var n = anh.length, hien = 0;

  lis.forEach(function (li, i) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "ric2-tv-nho";
    b.setAttribute("aria-label", "Show image " + (i + 1) + " of " + n);
    b.appendChild(li.querySelector("img"));
    li.appendChild(b);
    b.addEventListener("click", function () { chon(i); });
  });

  function chon(i) {
    hien = i;
    if (anh[i].srcset) chinh.setAttribute("srcset", anh[i].srcset);
    else chinh.removeAttribute("srcset");
    chinh.src = anh[i].src;
    chinh.alt = anh[i].alt;
    lis.forEach(function (li, k) {
      li.classList.toggle("is-chon", k === i);
      li.firstChild.setAttribute("aria-pressed", k === i ? "true" : "false");
    });
  }

  // anh chinh bam duoc de phong to
  oChinh.classList.add("ric2-tv-chinh");
  oChinh.setAttribute("role", "button");
  oChinh.setAttribute("tabindex", "0");
  oChinh.setAttribute("aria-label", "View larger image");
  var kinh = document.createElement("span");
  kinh.className = "ric2-tv-kinh";
  kinh.setAttribute("aria-hidden", "true");
  kinh.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
  oChinh.appendChild(kinh);
  oChinh.addEventListener("click", function () { mo(hien); });
  oChinh.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); mo(hien); }
  });

  // khung phong to
  var hop = document.createElement("div");
  hop.className = "ric2-tv-hop";
  hop.hidden = true;
  hop.setAttribute("role", "dialog");
  hop.setAttribute("aria-modal", "true");
  hop.setAttribute("aria-label", "Product images");
  var ray = document.createElement("div");
  ray.className = "ric2-tv-ray";
  anh.forEach(function (a) {
    var o = document.createElement("div");
    o.className = "ric2-tv-o";
    var im = document.createElement("img");
    if (a.srcset) {
      im.setAttribute("srcset", a.srcset);
      im.setAttribute("sizes", "100vw");
    }
    im.src = a.src;
    im.alt = a.alt;
    im.loading = "lazy";
    im.decoding = "async";
    o.appendChild(im);
    ray.appendChild(o);
  });
  function nut(lop, nhan, chu) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = lop;
    b.setAttribute("aria-label", nhan);
    b.innerHTML = chu;
    hop.appendChild(b);
    return b;
  }
  hop.appendChild(ray);
  var dong = nut("ric2-tv-dong", "Close", "&times;");
  var lui = nut("ric2-tv-lui", "Previous image", "&#8249;");
  var toi = nut("ric2-tv-toi", "Next image", "&#8250;");
  var dem = document.createElement("p");
  dem.className = "ric2-tv-dem";
  dem.setAttribute("aria-live", "polite");
  hop.appendChild(dem);
  goc.appendChild(hop);

  function oDangXem() {
    return Math.max(0, Math.min(n - 1, Math.round(ray.scrollLeft / (ray.clientWidth || 1))));
  }
  function capNhat() {
    var i = oDangXem();
    dem.textContent = i + 1 + " / " + n;
    lui.disabled = i === 0;
    toi.disabled = i === n - 1;
  }
  function den(i) {
    ray.scrollTo({ left: i * ray.clientWidth, behavior: "smooth" });
  }
  function mo(i) {
    hop.hidden = false;
    document.documentElement.classList.add("ric2-tv-khoa");
    ray.scrollLeft = i * ray.clientWidth;
    capNhat();
    dong.focus();
  }
  function tat() {
    var i = oDangXem();
    hop.hidden = true;
    document.documentElement.classList.remove("ric2-tv-khoa");
    chon(i);
    oChinh.focus();
  }
  var hen;
  ray.addEventListener("scroll", function () {
    clearTimeout(hen);
    hen = setTimeout(capNhat, 60);
  });
  dong.addEventListener("click", tat);
  lui.addEventListener("click", function () { den(oDangXem() - 1); });
  toi.addEventListener("click", function () { den(oDangXem() + 1); });
  document.addEventListener("keydown", function (e) {
    if (hop.hidden) return;
    if (e.key === "Escape") tat();
    else if (e.key === "ArrowLeft") den(oDangXem() - 1);
    else if (e.key === "ArrowRight") den(oDangXem() + 1);
  });
  window.addEventListener("resize", function () {
    if (!hop.hidden) ray.scrollLeft = oDangXem() * ray.clientWidth;
  });

  chon(0);
})();

/* ric2 "goi nay co gi": o khung mua dau trang, liet ke tick xanh nhung gi goi dang chon co, lay tu bang so sanh (khong viet them noi dung);
   goi co hop qua thi hien them dai anh that cac mon trong hop (lay tu muc "What comes in your first box"). Dan vao CUOI ric2-script.js */
(function () {
  "use strict";
  var goc = document.querySelector(".ric2-root");
  if (!goc) return;
  var bang = goc.querySelector(".pbg__bang");
  var moc = goc.querySelector(".ric2-mua__goi-dang");
  var radio = goc.querySelectorAll(".pbg__radio");
  if (!bang || !moc || !radio.length) return;

  // cot cua tung goi trong bang, tim theo gia o dau cot
  var giaCot = [].map.call(bang.querySelectorAll("thead .pbg__bang-gia"), function (s) { return s.textContent.trim(); });
  var hang = [].map.call(bang.querySelectorAll("tbody tr"), function (tr) {
    return {
      ten: tr.querySelector(".pbg__bang-ten-hang").textContent.trim(),
      o: [].map.call(tr.querySelectorAll(".pbg__bang-o"), function (td) {
        return td.classList.contains("pbg__bang-o--co") ? "co" : td.classList.contains("pbg__bang-o--nua") ? "nua" : "khong";
      })
    };
  });
  // "Refund window" doc kho hieu: dung dung cau cam ket da co tren trang
  var doiTen = { "Refund window": "Refund within 30 days of purchase. No reason needed, and you do not have to send the box back" };
  var HOP = "The devotional gift box";

  // cac mon trong hop qua: anh + ten that tu muc ptbx
  var mon = [].map.call(goc.querySelectorAll(".ptbx__o"), function (li) {
    var im = li.querySelector("img"), t = li.querySelector(".ptbx__ten");
    return im && t ? { src: im.getAttribute("src"), alt: im.getAttribute("alt") || "", ten: t.textContent.trim() } : null;
  }).filter(Boolean);

  var khung = document.createElement("div");
  khung.className = "ric2-gn";
  var td = document.createElement("p");
  td.className = "ric2-gn__td";
  var ds = document.createElement("ul");
  ds.className = "ric2-gn__ds";
  khung.appendChild(td);
  khung.appendChild(ds);

  var hopAnh = document.createElement("div");
  hopAnh.className = "ric2-gn__hop";
  var hopTd = document.createElement("p");
  hopTd.className = "ric2-gn__hop-td";
  hopTd.textContent = "Inside the gift box";
  var day = document.createElement("ul");
  day.className = "ric2-gn__day";
  mon.forEach(function (m) {
    var li = document.createElement("li");
    li.className = "ric2-gn__mon";
    var im = document.createElement("img");
    im.src = m.src;
    im.alt = "";
    im.loading = "lazy";
    im.decoding = "async";
    im.width = 400;
    im.height = 400;
    var t = document.createElement("span");
    t.textContent = m.ten;
    li.appendChild(im);
    li.appendChild(t);
    day.appendChild(li);
  });
  // cau ve hop hang thang: chi noi dieu dung tren trang (khong lap lai, giu bat ngo), giong moi, khong hua thay Chua
  var hopGhi = document.createElement("p");
  hopGhi.className = "ric2-gn__hop-ghi";
  hopGhi.textContent = "Above is Box 1. Every box after it is different — new pieces, a new theme, and no two months the same. We keep each month’s pieces a small surprise, so every box arrives as a fresh invitation to bring that month to God in prayer.";
  hopAnh.appendChild(hopTd);
  hopAnh.appendChild(day);
  hopAnh.appendChild(hopGhi);
  if (mon.length) khung.appendChild(hopAnh);

  // dat sau nut mua (truoc dong lien he), de nut mua van nam o man hinh dau
  var tt = moc.parentNode.querySelector(".ric2-mua__tt");
  moc.parentNode.insertBefore(khung, tt);

  function ve(nut) {
    var gia = nut.getAttribute("data-gia") || "";
    var cot = giaCot.indexOf(gia);
    if (cot < 0) { khung.hidden = true; return; }
    khung.hidden = false;
    td.textContent = "Included in your " + gia + " plan";
    ds.textContent = "";
    var coHop = false;
    hang.forEach(function (h) {
      var trangThai = h.o[cot];
      if (trangThai === "khong") return;
      if (h.ten === HOP && trangThai === "co") coHop = true;
      var li = document.createElement("li");
      li.className = "ric2-gn__mot" + (trangThai === "nua" ? " ric2-gn__mot--nua" : "");
      var dau = document.createElement("span");
      dau.className = "ric2-gn__dau";
      dau.setAttribute("aria-hidden", "true");
      dau.textContent = trangThai === "nua" ? "½" : "✓";
      var chu = document.createElement("span");
      chu.className = "ric2-gn__chu";
      chu.textContent = (doiTen[h.ten] || h.ten) + (trangThai === "nua" ? " (half)" : "");
      li.appendChild(dau);
      li.appendChild(chu);
      ds.appendChild(li);
    });
    hopAnh.hidden = !coHop;
  }

  for (var i = 0; i < radio.length; i++) {
    radio[i].addEventListener("change", function () { ve(this); });
    if (radio[i].checked) ve(radio[i]);
  }
})();

/* ric2 o so luong: them nut "−" va "+" to ro hai ben o so. Dan vao CUOI ric2-script.js */
(function () {
  "use strict";
  var goc = document.querySelector(".ric2-root");
  if (!goc) return;
  [].forEach.call(goc.querySelectorAll(".ric2-mua__sl input[type=number]"), function (o) {
    var min = parseInt(o.getAttribute("min"), 10) || 1;
    var hop = document.createElement("div");
    hop.className = "ric2-sl-hop";
    function nut(lop, nhan, chu, buoc) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ric2-sl-nut " + lop;
      b.setAttribute("aria-label", nhan);
      b.setAttribute("aria-controls", o.id);
      b.textContent = chu;
      b.addEventListener("click", function () {
        var v = parseInt(o.value, 10);
        o.value = Math.max(min, (isNaN(v) ? min : v) + buoc);
        o.dispatchEvent(new Event("change", { bubbles: true }));
      });
      return b;
    }
    var bot = nut("ric2-sl-nut--bot", "Decrease quantity", "−", -1);
    var them = nut("ric2-sl-nut--them", "Increase quantity", "+", 1);
    o.parentNode.insertBefore(hop, o);
    hop.appendChild(bot);
    hop.appendChild(o);
    hop.appendChild(them);
    function capNhat() {
      var v = parseInt(o.value, 10);
      if (isNaN(v) || v < min) v = min;
      bot.disabled = v <= min;
    }
    o.addEventListener("change", function () {
      var v = parseInt(o.value, 10);
      if (isNaN(v) || v < min) o.value = min;
      capNhat();
    });
    o.addEventListener("input", capNhat);
    capNhat();
  });
})();

/* ric2 nut mua: them gio tai cho giong pheu-199 — khong roi trang, ngan gio bung ra.
 * Ban sac su kien CartLinesUpdateEvent nhu product-form.js, nen ngan gio tu mo + ve lai,
 * brand-hop-theo-goi tu them hop dang ky dung plan, brand-ms-gan-khach tu gan khach.
 * KHONG di thang /checkout: hop chi duoc them tren trang cua theme.
 * Loi bat ky (khong nap duoc module, mang hong, Shopify bao loi) -> gui form thuong
 * (/cart/add -> trang gio) nhu truoc, khong bao gio chan viec mua. */
(function () {
  "use strict";
  var goc = document.querySelector(".ric2-root");
  if (!goc || !window.fetch || !window.FormData) return;
  var dangGui = false;
  var tuyen = (window.Theme && window.Theme.routes) || {};
  var urlThem = tuyen.cart_add_url || "/cart/add.js";
  var urlGio = (tuyen.cart_url || "/cart") + ".js";

  goc.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || f.tagName !== "FORM" || !f.closest("[data-ric2-form]")) return;
    e.preventDefault();
    if (dangGui) return;
    dangGui = true;
    var nut = f.querySelector('button[type="submit"][name="add"]');
    if (nut) nut.setAttribute("aria-busy", "true");

    // KHONG xin kem `sections`: gio dang rong thi ngan gio ve HTML do bang view transition
    // (cham), ve sau lan brand-hop-theo-goi them hop -> gio hien thieu dong hop. Khong co
    // `sections` thi moi lan cap nhat deu tai lai ngan gio, ban moi nhat thang.
    var fd = new FormData(f);

    function guiThuong() {
      dangGui = false;
      if (nut) nut.removeAttribute("aria-busy");
      f.submit(); // khong qua su kien submit nen khong lap lai
    }

    // Su kien nap tu <script type="module"> trong section: Shopify nen file nay va
    // doi import("@shopify/events") thanh require(...), chay la loi.
    Promise.resolve().then(function () {
      var Su = window.ric2CartLinesUpdateEvent;
      if (!Su) throw new Error("ric2: chua nap duoc @shopify/events");
      var hen = Su.createPromise();
      f.dispatchEvent(new Su({
        action: "add",
        context: "product",
        lines: [{ merchandiseId: String(fd.get("id")), quantity: Number(fd.get("quantity")) || 1 }],
        promise: hen.promise
      }));
      return fetch(urlThem, { method: "POST", body: fd, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (kq) {
          return fetch(urlGio, { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (gio) {
              var loi = Boolean(kq.status);
              hen.resolve({
                cart: Su.createCartFromAjaxResponse(gio),
                detail: { items: gio.items, source: "ric2", didError: loi }
              });
              if (loi) guiThuong();
            });
        })
        .catch(function (x) { hen.reject(x); throw x; });
    }).then(function () {
      dangGui = false;
      if (nut) nut.removeAttribute("aria-busy");
    }, guiThuong);
  });
})();
